const textContents = {
    "startPage": {
    "Finland": {"fin": "suomeksi", "rus": "Финский"},
    "Russia": {"fin": "venäjäksi", "rus": "Русский"},
    "Start": {"fin": "Aloita peli", "rus": "Начать игру"},
        "GameName": { "fin": ["VERBIT: ", "Masha kylässä"], "rus": ["ГЛАГОЛЫ: ", "Маша в деревне"]},
    "Welcome": {"fin": "Valitse pelin kieli", "rus": "Выбери язык игры"}
},
 "topMenu": {
    "NavbarFi": {"fin": "Su", "rus": "Фи"},
    "NavbarRu": {"fin": "Ve", "rus": "Ру"},
    "NavbarClose": {"fin": "X", "rus": "X"},
    "NavbarInfo": {"fin": "?", "rus": "?"},
    "GameTitle": {"fin": "Verbit: Masha kylässä", "rus": "Глаголы: Маша в деревне"}
},
 "textGame": {
     "HowToPlay": { "fin": "Kuinka pelata", "rus": "Как играть"},
     "HowToPlayText": {
         "fin": ["", "Valitse ruudun neljästä verbistä se,", "joka sopii kuvan juoneen, ", "ja napsauta sitä kursorilla.", "Nuolilla ”Takaisin” ja ”Eteenpäin” ", "voit palata katsomaan ", "suoritettuja tehtäviä.", "Peli sisältää 22 juonikuvaa.", "", "Onnea peliin!"],
         "rus": ["Из четырёх глаголов, ", "расположенных на экране, выбери тот,", "что подходит к сюжету картинки ", "и нажми на него курсором.", "По стрелочкам «Вперёд» и «Назад»", "можно вернуться и посмотреть ", "выполненные задания.", "В игре содержится", "22 сюжетных картинки.", "", "Удачи в игре!"]
     },
     "Continue": {"fin": "Jatka", "rus": "Продолжить" },
    "GameOver": {  "fin": "Hyvin tehty!", "rus": "Молодец!" },
    "FinishGame": {  "fin": "Pelin loppu", "rus": "Конец игры"},
    "TasksDone": {  "fin": "Kerro, mitä Masha teki koko päivän?", "rus": ["Расскажи, чем была занята", "Маша весь день"]},
     "PlayAgain": { "fin": "Aloita alusta", "rus": "Начать с начала" },
     "GameQuestion": { "fin": "Mitä Masha tekee? ", "rus": "Что делает Маша?" },
     "GameInfo": { "fin": "Valitse vastaus näytössä olevista sanoista", "rus": "Выбери глагол, подходящий к картинке" }
},
"content": {
    "ProsipaetsjaUtrom": {
        "fin": "Herää", 
        "rus": "Просыпается"
    },
    "RaschecyvaetVolosy": {
        "fin": "Kampaa", 
        "rus": "Причёсывается"
    },
    "UmyvaetsjaVodoy": {
        "fin": "Peseytyy", 
        "rus": "Умывается"
    },
    "ZapletaetKosu": {
        "fin": "Letittää", 
        "rus": "Заплетает"
    },
    "TopitPech": {
        "fin": "Lämmittää", 
        "rus": "Топит"
    },
    "KormitKoshku": {
        "fin": "Ruokkii", 
        "rus": "Кормит"
    },
    "ZavtrakaetKashey": {
        "fin": "Syö", 
        "rus": "Завтракает"
    },
    "PasetKorovu": {
        "fin": "Paimentaa", 
        "rus": "Пасёт"
    },
    "IdetZaVodoy": {
        "fin": "Kantaa", 
        "rus": "Несёт"
    },
    "StiraetBelje": {
        "fin": "Pesee", 
        "rus": "Стирает"
    },
    "Utjuzit": {
        "fin": "Silittää", 
        "rus": "Утюжит"
    },
    "StrjapaetPirozki": {
        "fin": "Leipoo", 
        "rus": "Стряпает"
    },
    "MoetPosudu": {
        "fin": "Pesee", 
        "rus": "Моет"
    },
    "PodmetaetPol": {
        "fin": "Lakaisee", 
        "rus": "Подметает"
    },
    "NarjazaetsjaSarafan": {
        "fin": "Pukeutuu", 
        "rus": "Наряжается"
    },
    "PoetTancuet": {
        "fin": "Tanssii", 
        "rus": "Танцует"
    },
    "ChaySamovar": {
        "fin": "Kaataa", 
        "rus": "Наливает"
    },
    "VyshivaetSalfetku": {
        "fin": "Kirjailee ", 
        "rus": "Вышивает"
    },
    "CshelkaetSemechki": {
        "fin": "Rouskuttaa", 
        "rus": "Щёлкает"
    },
    "DoitKorovu": {
        "fin": "Lypsää", 
        "rus": "Доит"
    },
    "PjotMoloko": {
        "fin": "Juo", 
        "rus": "Пьёт"
    },
    "PrjadetVeretenom": {
        "fin": "Kehrää", 
        "rus": "Прядёт"
    },
    "LozitsjaSpat": {
        "fin": "Nukkuu", 
        "rus": "Спит"  
    }
         
}
}
export default textContents;